const supportedCountries = [
  {
    name: "United Kingdom",
    country_code: "GB",
    currency: "British Pound Sterling",
    currency_code: "GBP",
    symbol: "£",
    continent: "Europe",
  },
  {
    name: "Canada",
    country_code: "CA",
    currency: "Canadian Dollar",
    currency_code: "CAD",
    symbol: "$",
    continent: "North America",
  },
  {
    name: "Cameroon",
    country_code: "CM",
    currency: "Central African CFA Franc",
    currency_code: "XAF",
    symbol: "FCFA",
    continent: "Africa",
  },
  {
    name: "Central African Republic",
    country_code: "CF",
    currency: "Central African CFA Franc",
    currency_code: "XAF",
    symbol: "FCFA",
    continent: "Africa",
  },
  {
    name: "Chad",
    country_code: "TD",
    currency: "Central African CFA Franc",
    currency_code: "XAF",
    symbol: "FCFA",
    continent: "Africa",
  },
  {
    name: "Republic of the Congo",
    country_code: "CG",
    currency: "Central African CFA Franc",
    currency_code: "XAF",
    symbol: "FCFA",
    continent: "Africa",
  },
  {
    name: "Equatorial Guinea",
    country_code: "GQ",
    currency: "Central African CFA Franc",
    currency_code: "XAF",
    symbol: "FCFA",
    continent: "Africa",
  },
  {
    name: "Gabon",
    country_code: "GA",
    currency: "Central African CFA Franc",
    currency_code: "XAF",
    symbol: "FCFA",
    continent: "Africa",
  },
  {
    name: "Chile",
    country_code: "CL",
    currency: "Chilean Peso",
    currency_code: "CLP",
    symbol: "$",
    continent: "South America",
  },
  {
    name: "Colombia",
    country_code: "CO",
    currency: "Colombian Peso",
    currency_code: "COP",
    symbol: "$",
    continent: "South America",
  },
  {
    name: "Egypt",
    country_code: "EG",
    currency: "Egyptian Pound",
    currency_code: "EGP",
    symbol: "£",
    continent: "Africa",
  },
  {
    name: "Austria",
    country_code: "AT",
    currency: "Euro",
    currency_code: "EUR",
    symbol: "€",
    continent: "Europe",
  },
  {
    name: "Belgium",
    country_code: "BE",
    currency: "Euro",
    currency_code: "EUR",
    symbol: "€",
    continent: "Europe",
  },
  {
    name: "France",
    country_code: "FR",
    currency: "Euro",
    currency_code: "EUR",
    symbol: "€",
    continent: "Europe",
  },
  {
    name: "Germany",
    country_code: "DE",
    currency: "Euro",
    currency_code: "EUR",
    symbol: "€",
    continent: "Europe",
  },
  {
    name: "Ireland",
    country_code: "IE",
    currency: "Euro",
    currency_code: "EUR",
    symbol: "€",
    continent: "Europe",
  },
  {
    name: "Italy",
    country_code: "IT",
    currency: "Euro",
    currency_code: "EUR",
    symbol: "€",
    continent: "Europe",
  },
  {
    name: "Netherlands",
    country_code: "NL",
    currency: "Euro",
    currency_code: "EUR",
    symbol: "€",
    continent: "Europe",
  },
  {
    name: "Portugal",
    country_code: "PT",
    currency: "Euro",
    currency_code: "EUR",
    symbol: "€",
    continent: "Europe",
  },
  {
    name: "Spain",
    country_code: "ES",
    currency: "Euro",
    currency_code: "EUR",
    symbol: "€",
    continent: "Europe",
  },
  {
    name: "Ghana",
    country_code: "GH",
    currency: "Ghanaian Cedi",
    currency_code: "GHS",
    symbol: "₵",
    continent: "Africa",
  },
  {
    name: "Guinea",
    country_code: "GN",
    currency: "Guinean Franc",
    currency_code: "GNF",
    symbol: "FG",
    continent: "Africa",
  },
  {
    name: "Kenya",
    country_code: "KE",
    currency: "Kenyan Shilling",
    currency_code: "KES",
    symbol: "KSh",
    continent: "Africa",
  },
  {
    name: "Malawi",
    country_code: "MW",
    currency: "Malawian Kwacha",
    currency_code: "MWK",
    symbol: "MK",
    continent: "Africa",
  },
  {
    name: "Morocco",
    country_code: "MA",
    currency: "Moroccan Dirham",
    currency_code: "MAD",
    symbol: "د.م.",
    continent: "Africa",
  },
  {
    name: "Nigeria",
    country_code: "NG",
    currency: "Nigerian Naira",
    currency_code: "NGN",
    symbol: "₦",
    continent: "Africa",
  },
  {
    name: "Rwanda",
    country_code: "RW",
    currency: "Rwandan Franc",
    currency_code: "RWF",
    symbol: "FRw",
    continent: "Africa",
  },
  {
    name: "Sierra Leone",
    country_code: "SL",
    currency: "Sierra Leonean Leone",
    currency_code: "SLL",
    symbol: "Le",
    continent: "Africa",
  },
  {
    name: "São Tomé and Príncipe",
    country_code: "ST",
    currency: "São Tomé and Príncipe Dobra",
    currency_code: "STD",
    symbol: "Db",
    continent: "Africa",
  },
  {
    name: "South Africa",
    country_code: "ZA",
    currency: "South African Rand",
    currency_code: "ZAR",
    symbol: "R",
    continent: "Africa",
  },
  {
    name: "Tanzania",
    country_code: "TZ",
    currency: "Tanzanian Shilling",
    currency_code: "TZS",
    symbol: "TSh",
    continent: "Africa",
  },
  {
    name: "Uganda",
    country_code: "UG",
    currency: "Ugandan Shilling",
    currency_code: "UGX",
    symbol: "USh",
    continent: "Africa",
  },
  {
    name: "United States",
    country_code: "US",
    currency: "United States Dollar",
    currency_code: "USD",
    symbol: "$",
    continent: "North America",
  },
  {
    name: "Benin",
    country_code: "BJ",
    currency: "West African CFA Franc BCEAO",
    currency_code: "XOF",
    symbol: "CFA",
    continent: "Africa",
  },
  {
    name: "Burkina Faso",
    country_code: "BF",
    currency: "West African CFA Franc BCEAO",
    currency_code: "XOF",
    symbol: "CFA",
    continent: "Africa",
  },
  {
    name: "Côte d’Ivoire",
    country_code: "CI",
    currency: "West African CFA Franc BCEAO",
    currency_code: "XOF",
    symbol: "CFA",
    continent: "Africa",
  },
  {
    name: "Guinea-Bissau",
    country_code: "GW",
    currency: "West African CFA Franc BCEAO",
    currency_code: "XOF",
    symbol: "CFA",
    continent: "Africa",
  },
  {
    name: "Mali",
    country_code: "ML",
    currency: "West African CFA Franc BCEAO",
    currency_code: "XOF",
    symbol: "CFA",
    continent: "Africa",
  },
  {
    name: "Niger",
    country_code: "NE",
    currency: "West African CFA Franc BCEAO",
    currency_code: "XOF",
    symbol: "CFA",
    continent: "Africa",
  },
  {
    name: "Senegal",
    country_code: "SN",
    currency: "West African CFA Franc BCEAO",
    currency_code: "XOF",
    symbol: "CFA",
    continent: "Africa",
  },
  {
    name: "Togo",
    country_code: "TG",
    currency: "West African CFA Franc BCEAO",
    currency_code: "XOF",
    symbol: "CFA",
    continent: "Africa",
  },
  {
    name: "Zambia",
    country_code: "ZM",
    currency: "Zambian Kwacha",
    currency_code: "ZMW",
    symbol: "ZK",
    continent: "Africa",
  },
].sort((a, b) => a.name.localeCompare(b.name));

export default supportedCountries;
